import { render, staticRenderFns } from "./AreYouSureBox.vue?vue&type=template&id=f13ead8e&"
import script from "./AreYouSureBox.vue?vue&type=script&lang=js&"
export * from "./AreYouSureBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports